// export default BrandInfo;
// import React, { useState, useRef, useEffect, useCallback } from 'react';
// import { useGoogleMaps } from '../../hooks/useGoogleMaps';

// const BrandInfo = ({ onComplete, initialBrand = '', initialTags = [] }) => {
//   const [brandName, setBrandName] = useState(initialBrand);
//   const [tags, setTags] = useState(initialTags);
//   const [inputTag, setInputTag] = useState('');
//   const [isBrandListening, setIsBrandListening] = useState(false);
//   const [isKeywordListening, setIsKeywordListening] = useState(false);
//   const brandRecognitionRef = useRef(null);
//   const keywordRecognitionRef = useRef(null);
//   const { isLoaded } = useGoogleMaps();
//   const autocompleteService = useRef(null);
//   const placesService = useRef(null);
//   const mapDivRef = useRef(null);
//   const [suggestions, setSuggestions] = useState([]);
//   const [showSuggestions, setShowSuggestions] = useState(false);
//   const [isLoadingPlace, setIsLoadingPlace] = useState(false);

//   const [websiteUrl, setWebsiteUrl] = useState('');
//   const [placeId, setPlaceId] = useState('');
//   const [locationCity, setLocationCity] = useState('');
//   const [fullAddress, setFullAddress] = useState('');
//   const [gmbLink, setGmbLink] = useState('');

//   const isStepValid = brandName.trim().length > 1 && tags.length >= 5;
//   const MIN_TAGS = 5;
//   const MAX_TAGS = 20;

//   const tagsRef = useRef(tags);
//   useEffect(() => { tagsRef.current = tags; }, [tags]);

//   useEffect(() => {
//     if (!isLoaded) return;
//     autocompleteService.current = new window.google.maps.places.AutocompleteService();
//     mapDivRef.current = document.createElement('div');
//     placesService.current = new window.google.maps.places.PlacesService(mapDivRef.current);
//   }, [isLoaded]);

//   useEffect(() => {
//     return () => {
//       try { brandRecognitionRef.current?.abort(); } catch {}
//       try { keywordRecognitionRef.current?.abort(); } catch {}
//     };
//   }, []);

//   const addTag = useCallback((text) => {
//     const trimmed = text.trim().replace(/,+$/, '');
//     if (!trimmed || trimmed.length < 2) return;
//     setTags(prev => {
//       const exists = prev.some(t => t.toLowerCase() === trimmed.toLowerCase());
//       if (exists || prev.length >= MAX_TAGS) return prev;
//       return [...prev, trimmed];
//     });
//   }, []);

//   const removeTag = useCallback((tagToRemove) => {
//     setTags(prev => prev.filter(t => t !== tagToRemove));
//   }, []);

//   const handleBrandChange = (e) => {
//     const value = e.target.value;
//     setBrandName(value);
//     if (!autocompleteService.current || value.length < 2) {
//       setSuggestions([]);
//       setShowSuggestions(false);
//       return;
//     }
//     autocompleteService.current.getPlacePredictions(
//       { input: value, types: ['establishment'] },
//       (predictions, status) => {
//         if (status === window.google.maps.places.PlacesServiceStatus.OK) {
//           setSuggestions(predictions || []);
//           setShowSuggestions(true);
//         } else {
//           setSuggestions([]);
//           setShowSuggestions(false);
//         }
//       }
//     );
//   };

//   const selectSuggestion = (prediction) => {
//     setBrandName(prediction.structured_formatting.main_text);
//     setSuggestions([]);
//     setShowSuggestions(false);
//     if (!placesService.current) return;
//     setIsLoadingPlace(true);
//     placesService.current.getDetails(
//       {
//         placeId: prediction.place_id,
//         fields: ['name', 'website', 'formatted_address', 'geometry', 'url',
//                  'address_components', 'international_phone_number', 'place_id'],
//       },
//       (place, status) => {
//         setIsLoadingPlace(false);
//         if (status !== window.google.maps.places.PlacesServiceStatus.OK || !place) return;
//         if (place.website) setWebsiteUrl(place.website);
//         setGmbLink(`https://share.google/${place.place_id}`);
//         setPlaceId(place.place_id);
//         setFullAddress(place.formatted_address || '');

//         const components = place.address_components || [];
//         let area = '', city = '';
//         const getAreaScore = (types) => {
//           if (types.includes('sublocality_level_2')) return 5;
//           if (types.includes('sublocality_level_1')) return 4;
//           if (types.includes('sublocality'))         return 3;
//           if (types.includes('neighborhood'))        return 2;
//           if (types.includes('route'))               return 1;
//           return 0;
//         };
//         let bestScore = 0;
//         components.forEach(c => {
//           const score = getAreaScore(c.types);
//           if (score > bestScore) { bestScore = score; area = c.long_name; }
//         });
//         const cityComp =
//           components.find(c => c.types.includes('locality')) ||
//           components.find(c => c.types.includes('administrative_area_level_2')) ||
//           components.find(c => c.types.includes('administrative_area_level_1'));
//         if (cityComp) city = cityComp.long_name;

//         if (!area || !city) {
//           const parts = place.formatted_address?.split(',').map(p => p.trim()) || [];
//           if (!city && parts.length >= 2) city = parts[parts.length - 3] || parts[parts.length - 2];
//           if (!area && parts.length >= 3) area = parts[parts.length - 4] || parts[parts.length - 3];
//         }
//         setLocationCity([area, city].filter(Boolean).join(', ') || '');
//       }
//     );
//   };

//   const handleTagKeyDown = (e) => {
//     if (e.key === 'Enter' || e.key === ',') {
//       e.preventDefault();
//       if (inputTag.trim()) {
//         addTag(inputTag);
//         setInputTag('');
//       }
//     }
//     if (e.key === 'Backspace' && !inputTag) {
//       setTags(prev => prev.slice(0, -1));
//     }
//   };

//   const buildRecognition = useCallback((recognitionRefToUse, onFinalResult, onInterim) => {
//     const SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;
//     if (!SpeechRecognition) {
//       alert('Voice input requires Chrome or Edge');
//       return null;
//     }
//     if (recognitionRefToUse.current) {
//       try { recognitionRefToUse.current.abort(); } catch {}
//       recognitionRefToUse.current = null;
//     }
//     const recognition = new SpeechRecognition();
//     recognition.continuous = false;
//     recognition.interimResults = true;
//     recognition.lang = 'en-IN';
//     recognition.maxAlternatives = 1;
//     let silenceTimer = null;
//     let finalTranscript = '';
//     const resetTimer = () => {
//       if (silenceTimer) clearTimeout(silenceTimer);
//       silenceTimer = setTimeout(() => recognition.stop(), 2000);
//     };
//     recognition.onstart = () => { finalTranscript = ''; };
//     recognition.onresult = (event) => {
//       resetTimer();
//       let interim = '';
//       for (let i = event.resultIndex; i < event.results.length; i++) {
//         const t = event.results[i][0].transcript;
//         if (event.results[i].isFinal) {
//           finalTranscript += t + ' ';
//         } else {
//           interim = t;
//         }
//       }
//       if (onInterim) onInterim(interim || finalTranscript.trim());
//     };
//     recognition.onend = () => {
//       if (silenceTimer) clearTimeout(silenceTimer);
//       const result = finalTranscript.trim();
//       if (result && onFinalResult) onFinalResult(result);
//       finalTranscript = '';
//     };
//     recognition.onerror = (e) => {
//       console.warn('Speech error:', e.error);
//     };
//     return recognition;
//   }, []);

//   const startBrandVoice = useCallback(() => {
//     if (isBrandListening) {
//       brandRecognitionRef.current?.stop();
//       setIsBrandListening(false);
//       return;
//     }
//     const recognition = buildRecognition(
//       brandRecognitionRef,
//       (result) => {
//         setBrandName(result);
//         if (autocompleteService.current && result.length >= 2) {
//           autocompleteService.current.getPlacePredictions(
//             { input: result, types: ['establishment'] },
//             (predictions, status) => {
//               if (status === window.google.maps.places.PlacesServiceStatus.OK) {
//                 setSuggestions(predictions || []);
//                 setShowSuggestions(true);
//               }
//             }
//           );
//         }
//         setIsBrandListening(false);
//       },
//       (interim) => setBrandName(interim)
//     );
//     if (!recognition) return;
//     brandRecognitionRef.current = recognition;
//     setIsBrandListening(true);
//     recognition.start();
//   }, [isBrandListening, buildRecognition]);

//   const startKeywordVoice = useCallback(() => {
//     if (isKeywordListening) {
//       keywordRecognitionRef.current?.stop();
//       setIsKeywordListening(false);
//       return;
//     }
//     const recognition = buildRecognition(
//       keywordRecognitionRef,
//       (result) => {
//         const parts = result
//           .split(/,|;|\band\b|\balso\b/gi)
//           .map(p => p.trim().replace(/[.!?]+$/, ''))
//           .filter(p => p.length > 1);
//         parts.forEach(part => addTag(part));
//         setInputTag('');
//         setIsKeywordListening(false);
//       },
//       (interim) => setInputTag(interim)
//     );
//     if (!recognition) return;
//     keywordRecognitionRef.current = recognition;
//     setIsKeywordListening(true);
//     recognition.start();
//   }, [isKeywordListening, buildRecognition, addTag]);

//   const handleNext = () => {
//     if (isStepValid) {
//       onComplete({ brandName, tags, websiteUrl, placeId, location: locationCity, fullAddress, gmbLink });
//     }
//   };

//   return (
//     <>
//       {/* <div className="eyebrow">Step 1 of 3</div> */}
//       <h2 className="ctitle">Tell us about the brand</h2>
//       <p className="cdesc">Start with the business name and the keywords that best describe what they offer.</p>

//       {/* Brand Name & Mic */}
//       <div style={{ marginBottom: '20px', position: 'relative' }}>
//         <div className="flbl">Business Name <span className="req">*</span></div>
//         <div className="irow">
//           <div style={{ position: 'relative', flex: 1 }}>
//             <input
//               type="text"
//               className="tinput"
//               value={brandName}
//               onChange={handleBrandChange}
//               onBlur={() => setTimeout(() => setShowSuggestions(false), 150)}
//               placeholder="e.g. Thistle Media"
//               autoComplete="off"
//             />
//             {isLoadingPlace && (
//               <div style={{
//                 position: 'absolute', right: 12, top: '50%',
//                 transform: 'translateY(-50%)', fontSize: 13, color: 'var(--mutedl)',
//               }}>
//                 Fetching details...
//               </div>
//             )}
//             {showSuggestions && suggestions.length > 0 && (
//               <div className="aclist" style={{ display: 'block' }}>
//                 {suggestions.map(pred => (
//                   <div
//                     key={pred.place_id}
//                     className="acitem"
//                     onMouseDown={(e) => { e.preventDefault(); selectSuggestion(pred); }}
//                     style={{
//                       display: 'flex', flexDirection: 'column',
//                       gap: 2, padding: '10px 14px', cursor: 'pointer',
//                     }}
//                   >
//                     <span style={{ fontWeight: 500, fontSize: 14, color: 'var(--text)' }}>
//                       {pred.structured_formatting.main_text}
//                     </span>
//                     <small style={{ fontSize: 12, color: 'var(--muted)', lineHeight: 1.3 }}>
//                       {pred.structured_formatting.secondary_text}
//                     </small>
//                   </div>
//                 ))}
//               </div>
//             )}
//           </div>
//           <button
//             className={`mic ${isBrandListening ? 'on' : ''}`}
//             onClick={startBrandVoice}
//             type="button"
//           >
//             <svg viewBox="0 0 24 24" fill={isBrandListening ? 'white' : 'var(--muted)'}>
//               <path d="M12 14c1.7 0 3-1.3 3-3V5c0-1.7-1.3-3-3-3S9 3.3 9 5v6c0 1.7 1.3 3 3 3zm5.3-3c0 3-2.5 5.1-5.3 5.1S6.7 14 6.7 11H5c0 3.4 2.7 6.2 6 6.7V21h2v-3.3c3.3-.5 6-3.3 6-6.7h-1.7z"/>
//             </svg>
//           </button>
//         </div>
//         <div className={`vs ${isBrandListening ? 'show' : ''}`}>
//           <div className="vwave"><span></span><span></span><span></span><span></span><span></span></div>
//           Listening…
//         </div>
//       </div>

//       {/* Keywords & Mic */}
//       <div style={{ marginBottom: '20px' }}>
//         <div className="flbl">Services / Product Keywords<span className="req">*</span>
//             {/* <span className="khint">(Press enter after each keyword)</span> */}
//         </div>
//         <div className="irow" style={{ alignItems: 'flex-start' }}>
//           <div style={{ flex: 1 }}>
//             <div className="twrap" onClick={() => document.getElementById('tinp')?.focus()}>
//               {tags.map(tag => (
//                 <div key={tag} className="tag">
//                   {tag}
//                   <button
//                     className="trm"
//                     type="button"
//                     onMouseDown={(e) => { e.preventDefault(); e.stopPropagation(); removeTag(tag); }}
//                   >
//                     ✕
//                   </button>
//                 </div>
//               ))}
//               <input
//                 type="text"
//                 className="tinp"
//                 id="tinp"
//                 value={inputTag}
//                 onChange={(e) => setInputTag(e.target.value)}
//                 onKeyDown={handleTagKeyDown}
//                 placeholder={
//                   isKeywordListening ? 'Speak now…' :
//                   tags.length === 0 ? 'Type a keyword and press Enter…' :
//                   'Add more keywords…'
//                 }
//                 disabled={isKeywordListening}
//               />
//             </div>
//             <div className="kbar-track">
//               <div className="kbar" style={{ width: `${(tags.length / MAX_TAGS) * 100}%` }} />
//             </div>
//             <div className="kfoot">
//               <span className="khint">
//                 {tags.length === 0
//                   ? `Add at least ${MIN_TAGS} keywords to continue`
//                   : tags.length < MIN_TAGS
//                   ? `${MIN_TAGS - tags.length} more keyword${MIN_TAGS - tags.length > 1 ? 's' : ''} needed`
//                   : tags.length >= MAX_TAGS
//                   ? 'Maximum 20 keywords reached'
//                   : `${tags.length} keyword${tags.length > 1 ? 's' : ''} added — ${MAX_TAGS - tags.length} more allowed`}
//               </span>
//               <span className="kcount"><span className="n">{tags.length}</span>&nbsp;/ {MAX_TAGS}</span>
//             </div>
//             <div className={`kwarn ${tags.length > 0 && tags.length < MIN_TAGS ? 'show' : ''}`}>
//               ⚠ Minimum 5 keywords required
//             </div>
//           </div>
//           <button
//             className={`mic ${isKeywordListening ? 'on' : ''}`}
//             style={{ marginTop: 4 }}
//             onClick={startKeywordVoice}
//             type="button"
//           >
//             <svg viewBox="0 0 24 24" fill={isKeywordListening ? 'white' : 'var(--muted)'}>
//               <path d="M12 14c1.7 0 3-1.3 3-3V5c0-1.7-1.3-3-3-3S9 3.3 9 5v6c0 1.7 1.3 3 3 3zm5.3-3c0 3-2.5 5.1-5.3 5.1S6.7 14 6.7 11H5c0 3.4 2.7 6.2 6 6.7V21h2v-3.3c3.3-.5 6-3.3 6-6.7h-1.7z"/>
//             </svg>
//           </button>
//         </div>
//         <div className={`vs ${isKeywordListening ? 'show' : ''}`}>
//           <div className="vwave"><span></span><span></span><span></span><span></span><span></span></div>
//           Listening — speak your keywords…
//         </div>
//       </div>

//       <button className="btn" onClick={handleNext} disabled={!isStepValid}>
//         {/* Continue to GMB Profile */}
//         See Your Brand Overview
//         <svg viewBox="0 0 24 24">
//           <path d="M12 4l-1.4 1.4L16.2 11H4v2h12.2l-5.6 5.6L12 20l8-8z"/>
//         </svg>
//       </button>
//     </>
//   );
// };

// export default BrandInfo;
import React, { useState, useRef, useEffect, useCallback } from 'react';
import { useGoogleMaps } from '../../hooks/useGoogleMaps';
// ─── CONFIG ──────────────────────────────────────────────────────────────────

const OPENAI_API_KEY =
  process.env.REACT_APP_OPENAI_API_KEY || '';
const GPT_MODEL =
  process.env.REACT_APP_GPT_MODEL || 'gpt-4o-mini';
// Use backend proxy in production for security
const USE_PROXY = false;
const OPENAI_PROXY_URL = '/api/generate-keywords';

// ─────────────────────────────────────────────────────────────────────────────

const BrandInfo = ({ onComplete, initialBrand = '', initialTags = [] }) => {
  const [brandName, setBrandName]           = useState(initialBrand);
  const [tags, setTags]                     = useState(initialTags);
  const [inputTag, setInputTag]             = useState('');
  const [isBrandListening, setIsBrandListening]     = useState(false);
  const [isKeywordListening, setIsKeywordListening] = useState(false);
  const [isGenerating, setIsGenerating]     = useState(false);
  const [genError, setGenError]             = useState('');

  const brandRecognitionRef   = useRef(null);
  const keywordRecognitionRef = useRef(null);
  const { isLoaded }          = useGoogleMaps();
  const autocompleteService   = useRef(null);
  const placesService         = useRef(null);
  const mapDivRef             = useRef(null);

  const [suggestions, setSuggestions]   = useState([]);
  const [showSuggestions, setShowSuggestions] = useState(false);
  const [isLoadingPlace, setIsLoadingPlace]   = useState(false);

  const [websiteUrl, setWebsiteUrl]     = useState('');
  const [placeId, setPlaceId]           = useState('');
  const [locationCity, setLocationCity] = useState('');
  const [fullAddress, setFullAddress]   = useState('');
  const [gmbLink, setGmbLink]           = useState('');

  const MIN_TAGS = 10;
  const MAX_TAGS = 20;

  const isStepValid = brandName.trim().length > 1 && tags.length >= MIN_TAGS;
  // 1. Switch to proxy
  const USE_PROXY = true;

  // 2. Point to your backend
  const OPENAI_PROXY_URL = `${process.env.REACT_APP_API_BASE}/api/generate-keywords`;

  const tagsRef = useRef(tags);
  useEffect(() => { tagsRef.current = tags; }, [tags]);

  useEffect(() => {
    if (!isLoaded) return;
    autocompleteService.current = new window.google.maps.places.AutocompleteService();
    mapDivRef.current = document.createElement('div');
    placesService.current = new window.google.maps.places.PlacesService(mapDivRef.current);
  }, [isLoaded]);

  useEffect(() => {
    return () => {
      try { brandRecognitionRef.current?.abort(); }   catch {}
      try { keywordRecognitionRef.current?.abort(); } catch {}
    };
  }, []);

  // ─── TAG HELPERS ───────────────────────────────────────────────────────────

  const addTag = useCallback((text) => {
    const trimmed = text.trim().replace(/,+$/, '');
    if (!trimmed || trimmed.length < 2) return;
    setTags(prev => {
      const exists = prev.some(t => t.toLowerCase() === trimmed.toLowerCase());
      if (exists || prev.length >= MAX_TAGS) return prev;
      return [...prev, trimmed];
    });
  }, []);

  const removeTag = useCallback((tagToRemove) => {
    setTags(prev => prev.filter(t => t !== tagToRemove));
  }, []);

  // ─── CHATGPT KEYWORD GENERATION ────────────────────────────────────────────

// ─── GENERATE KEYWORDS ──────────────────────────────────────────────────────

const generateKeywords = async ({
  brand   = brandName,
  website = websiteUrl,
  city    = locationCity,
  address = fullAddress,
} = {}) => {
  if (!brand.trim()) return;
  setIsGenerating(true);
  setGenError('');

  try {
    const res = await fetch(`${process.env.REACT_APP_API_BASE}/api/generate-keywords`, {
      method : 'POST',
      headers: {
        'Content-Type' : 'application/json',
        'X-Secret-Token': process.env.REACT_APP_SECRET_TOKEN || '',
      },
      body: JSON.stringify({ brand, website, city, address }),
    });

    if (!res.ok) {
      const err = await res.json().catch(() => ({}));
      throw new Error(err?.detail || `Server error ${res.status}`);
    }

    const { keywords } = await res.json();

    if (!Array.isArray(keywords) || keywords.length === 0) {
      throw new Error('Unexpected response from server.');
    }

    keywords.slice(0, 15).forEach(kw => {
      if (typeof kw === 'string' && kw.trim()) addTag(kw.trim());
    });

  } catch (err) {
    console.error('Keyword generation failed:', err);
    setGenError(err?.message || 'Failed to generate keywords. Please try again.');
  } finally {
    setIsGenerating(false);
  }
};

// ─── BRAND AUTOCOMPLETE ────────────────────────────────────────────────────

  const handleBrandChange = (e) => {
    const value = e.target.value;
    setBrandName(value);
    if (!autocompleteService.current || value.length < 2) {
      setSuggestions([]);
      setShowSuggestions(false);
      return;
    }
    autocompleteService.current.getPlacePredictions(
      { input: value, types: ['establishment'] },
      (predictions, status) => {
        if (status === window.google.maps.places.PlacesServiceStatus.OK) {
          setSuggestions(predictions || []);
          setShowSuggestions(true);
        } else {
          setSuggestions([]);
          setShowSuggestions(false);
        }
      }
    );
  };

  const selectSuggestion = (prediction) => {
    setBrandName(prediction.structured_formatting.main_text);
    setSuggestions([]);
    setShowSuggestions(false);
    if (!placesService.current) return;
    setIsLoadingPlace(true);
    placesService.current.getDetails(
      {
        placeId: prediction.place_id,
        fields: [
          'name', 'website', 'formatted_address', 'geometry', 'url',
          'address_components', 'international_phone_number', 'place_id',
        ],
      },
      (place, status) => {
        setIsLoadingPlace(false);
        if (status !== window.google.maps.places.PlacesServiceStatus.OK || !place) return;

        if (place.website)          setWebsiteUrl(place.website);
        if (place.place_id)         setGmbLink(`https://share.google/${place.place_id}`);
        if (place.place_id)         setPlaceId(place.place_id);
        if (place.formatted_address) setFullAddress(place.formatted_address);

        // collect fresh values first
        const freshWebsite = place.website || '';
        const freshAddress = place.formatted_address || '';
        const freshPlaceId = place.place_id || '';

        if (freshWebsite)  setWebsiteUrl(freshWebsite);
        if (freshPlaceId)  setGmbLink(`https://share.google/${freshPlaceId}`);
        if (freshPlaceId)  setPlaceId(freshPlaceId);
        if (freshAddress)  setFullAddress(freshAddress);

        const components = place.address_components || [];
        let area = '', city = '';

        const getAreaScore = (types) => {
          if (types.includes('sublocality_level_2')) return 5;
          if (types.includes('sublocality_level_1')) return 4;
          if (types.includes('sublocality'))         return 3;
          if (types.includes('neighborhood'))        return 2;
          if (types.includes('route'))               return 1;
          return 0;
        };

        let bestScore = 0;
        components.forEach(c => {
          const score = getAreaScore(c.types);
          if (score > bestScore) { bestScore = score; area = c.long_name; }
        });

        const cityComp =
          components.find(c => c.types.includes('locality')) ||
          components.find(c => c.types.includes('administrative_area_level_2')) ||
          components.find(c => c.types.includes('administrative_area_level_1'));
        if (cityComp) city = cityComp.long_name;

        if (!area || !city) {
          const parts = place.formatted_address?.split(',').map(p => p.trim()) || [];
          if (!city && parts.length >= 2) city = parts[parts.length - 3] || parts[parts.length - 2];
          if (!area && parts.length >= 3) area = parts[parts.length - 4] || parts[parts.length - 3];
        }

        const freshCity = [area, city].filter(Boolean).join(', ') || '';
        setLocationCity([area, city].filter(Boolean).join(', ') || '');
         // ✅ Auto-trigger with fresh values — no stale state issue
        generateKeywords({
          brand: prediction.structured_formatting.main_text,
          website: freshWebsite,
          city: freshCity,
          address: freshAddress,
        });
      }
    );
  };

  // ─── TAG INPUT ─────────────────────────────────────────────────────────────

  const handleTagKeyDown = (e) => {
    if (e.key === 'Enter' || e.key === ',') {
      e.preventDefault();
      if (inputTag.trim()) { addTag(inputTag); setInputTag(''); }
    }
    if (e.key === 'Backspace' && !inputTag) {
      setTags(prev => prev.slice(0, -1));
    }
  };

  // ─── VOICE ─────────────────────────────────────────────────────────────────

  const buildRecognition = useCallback((recognitionRefToUse, onFinalResult, onInterim) => {
    const SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;
    if (!SpeechRecognition) { alert('Voice input requires Chrome or Edge'); return null; }
    if (recognitionRefToUse.current) {
      try { recognitionRefToUse.current.abort(); } catch {}
      recognitionRefToUse.current = null;
    }
    const recognition = new SpeechRecognition();
    recognition.continuous      = false;
    recognition.interimResults  = true;
    recognition.lang            = 'en-IN';
    recognition.maxAlternatives = 1;
    let silenceTimer = null;
    let finalTranscript = '';
    const resetTimer = () => {
      if (silenceTimer) clearTimeout(silenceTimer);
      silenceTimer = setTimeout(() => recognition.stop(), 2000);
    };
    recognition.onstart  = () => { finalTranscript = ''; };
    recognition.onresult = (event) => {
      resetTimer();
      let interim = '';
      for (let i = event.resultIndex; i < event.results.length; i++) {
        const t = event.results[i][0].transcript;
        if (event.results[i].isFinal) finalTranscript += t + ' ';
        else interim = t;
      }
      if (onInterim) onInterim(interim || finalTranscript.trim());
    };
    recognition.onend   = () => {
      if (silenceTimer) clearTimeout(silenceTimer);
      const result = finalTranscript.trim();
      if (result && onFinalResult) onFinalResult(result);
      finalTranscript = '';
    };
    recognition.onerror = (e) => console.warn('Speech error:', e.error);
    return recognition;
  }, []);

  const startBrandVoice = useCallback(() => {
    if (isBrandListening) {
      brandRecognitionRef.current?.stop();
      setIsBrandListening(false);
      return;
    }
    const recognition = buildRecognition(
      brandRecognitionRef,
      (result) => {
        setBrandName(result);
        if (autocompleteService.current && result.length >= 2) {
          autocompleteService.current.getPlacePredictions(
            { input: result, types: ['establishment'] },
            (predictions, status) => {
              if (status === window.google.maps.places.PlacesServiceStatus.OK) {
                setSuggestions(predictions || []);
                setShowSuggestions(true);
              }
            }
          );
        }
        setIsBrandListening(false);
      },
      (interim) => setBrandName(interim)
    );
    if (!recognition) return;
    brandRecognitionRef.current = recognition;
    setIsBrandListening(true);
    recognition.start();
  }, [isBrandListening, buildRecognition]);

  const startKeywordVoice = useCallback(() => {
    if (isKeywordListening) {
      keywordRecognitionRef.current?.stop();
      setIsKeywordListening(false);
      return;
    }
    const recognition = buildRecognition(
      keywordRecognitionRef,
      (result) => {
        const parts = result
          .split(/,|;|\band\b|\balso\b/gi)
          .map(p => p.trim().replace(/[.!?]+$/, ''))
          .filter(p => p.length > 1);
        parts.forEach(part => addTag(part));
        setInputTag('');
        setIsKeywordListening(false);
      },
      (interim) => setInputTag(interim)
    );
    if (!recognition) return;
    keywordRecognitionRef.current = recognition;
    setIsKeywordListening(true);
    recognition.start();
  }, [isKeywordListening, buildRecognition, addTag]);

  // ─── SUBMIT ────────────────────────────────────────────────────────────────

  const handleNext = () => {
    if (isStepValid) {
      onComplete({ brandName, tags, websiteUrl, placeId, location: locationCity, fullAddress, gmbLink });
    }
  };

  // ─── RENDER ────────────────────────────────────────────────────────────────

  return (
    <>
      <h2 className="ctitle">Tell us about the brand</h2>
      <p className="cdesc">
        Start with the business name and the keywords that best describe what they offer.
      </p>

      {/* ── Brand Name ── */}
      <div style={{ marginBottom: '20px', position: 'relative' }}>
        <div className="flbl">
          Business Name <span className="req">*</span>
        </div>
        <div className="irow">
          <div style={{ position: 'relative', flex: 1 }}>
            <input
              type="text"
              className="tinput"
              value={brandName}
              onChange={handleBrandChange}
              onBlur={() => setTimeout(() => setShowSuggestions(false), 150)}
              placeholder="e.g. Thistle Media"
              autoComplete="off"
            />
            {isLoadingPlace && (
              <div style={{
                position: 'absolute', right: 12, top: '50%',
                transform: 'translateY(-50%)', fontSize: 13, color: 'var(--mutedl)',
              }}>
                Fetching details…
              </div>
            )}
            {showSuggestions && suggestions.length > 0 && (
              <div className="aclist" style={{ display: 'block' }}>
                {suggestions.map(pred => (
                  <div
                    key={pred.place_id}
                    className="acitem"
                    onMouseDown={(e) => { e.preventDefault(); selectSuggestion(pred); }}
                    style={{
                      display: 'flex', flexDirection: 'column',
                      gap: 2, padding: '10px 14px', cursor: 'pointer',
                    }}
                  >
                    <span style={{ fontWeight: 500, fontSize: 14, color: 'var(--text)' }}>
                      {pred.structured_formatting.main_text}
                    </span>
                    <small style={{ fontSize: 12, color: 'var(--muted)', lineHeight: 1.3 }}>
                      {pred.structured_formatting.secondary_text}
                    </small>
                  </div>
                ))}
              </div>
            )}
          </div>

          <button
            className={`mic ${isBrandListening ? 'on' : ''}`}
            onClick={startBrandVoice}
            type="button"
          >
            <svg viewBox="0 0 24 24" fill={isBrandListening ? 'white' : 'var(--muted)'}>
              <path d="M12 14c1.7 0 3-1.3 3-3V5c0-1.7-1.3-3-3-3S9 3.3 9 5v6c0 1.7 1.3 3 3 3zm5.3-3c0 3-2.5 5.1-5.3 5.1S6.7 14 6.7 11H5c0 3.4 2.7 6.2 6 6.7V21h2v-3.3c3.3-.5 6-3.3 6-6.7h-1.7z"/>
            </svg>
          </button>
        </div>

        <div className={`vs ${isBrandListening ? 'show' : ''}`}>
          <div className="vwave">
            <span/><span/><span/><span/><span/>
          </div>
          Listening…
        </div>
      </div>

      {/* ── Keywords ── */}
      <div style={{ marginBottom: '20px' }}>
        <div className="flbl">
          Services / Product Keywords<span className="req">*</span>
        </div>

        {/* AI Generate button — shows once brand name is ready */}
        {brandName.trim().length > 1 && (
          <div style={{ marginBottom: 8 }}>
            {/* <button
              type="button"
              onClick={generateKeywords}
              disabled={isGenerating}
              style={{
                display: 'inline-flex',
                alignItems: 'center',
                gap: 7,
                background: isGenerating
                  ? 'var(--color-background-secondary, #f4f4f4)'
                  : 'linear-gradient(135deg, #6860E8 0%, #9B5CDB 100%)',
                border: 'none',
                color: isGenerating ? 'var(--muted, #888)' : '#fff',
                borderRadius: 8,
                padding: '8px 15px',
                fontSize: 13,
                fontWeight: 500,
                cursor: isGenerating ? 'not-allowed' : 'pointer',
                transition: 'opacity .15s, transform .1s',
                opacity: isGenerating ? 0.7 : 1,
                boxShadow: isGenerating ? 'none' : '0 2px 8px rgba(104,96,232,.35)',
              }}
            >
              {isGenerating ? (
                <>
                  <SpinnerIcon />
                  Generating keywords…
                </>
              ) : (
                <>
                  <SparkleIcon />
                  Suggest keywords with AI
                </>
              )}
            </button> */}

            {/* Error message */}
            {genError && (
              <div style={{
                marginTop: 6, fontSize: 12,
                color: 'var(--color-danger, #c0392b)',
                display: 'flex', alignItems: 'center', gap: 5,
              }}>
                <span>⚠</span> {genError}
              </div>
            )}

            {/* Context hint showing what data will be used */}
            {!genError && (
              <div style={{ marginTop: 5, fontSize: 11, color: 'var(--muted, #999)' }}>
                {websiteUrl
                  ? `Using website, location & business name to generate keywords`
                  : locationCity
                  ? `Using business name & location (${locationCity})`
                  : `Using business name — select from the list above for better results`}
              </div>
            )}
          </div>
        )}

        <div className="irow" style={{ alignItems: 'flex-start' }}>
          <div style={{ flex: 1 }}>
            <div
              className="twrap"
              onClick={() => document.getElementById('tinp')?.focus()}
            >
              {tags.map(tag => (
                <div key={tag} className="tag">
                  {tag}
                  <button
                    className="trm"
                    type="button"
                    onMouseDown={(e) => {
                      e.preventDefault();
                      e.stopPropagation();
                      removeTag(tag);
                    }}
                  >
                    ✕
                  </button>
                </div>
              ))}
              <input
                type="text"
                className="tinp"
                id="tinp"
                value={inputTag}
                onChange={(e) => setInputTag(e.target.value)}
                onKeyDown={handleTagKeyDown}
                placeholder={
                  isKeywordListening ? 'Speak now…' :
                  tags.length === 0   ? 'Type a keyword and press Enter…' :
                                        'Add more keywords…'
                }
                disabled={isKeywordListening}
              />
            </div>

            <div className="kbar-track">
              <div className="kbar" style={{ width: `${(tags.length / MAX_TAGS) * 100}%` }} />
            </div>

            <div className="kfoot">
              <span className="khint">
                {tags.length === 0
                  ? `Add at least ${MIN_TAGS} keywords to continue`
                  : tags.length < MIN_TAGS
                  ? `${MIN_TAGS - tags.length} more keyword${MIN_TAGS - tags.length > 1 ? 's' : ''} needed`
                  : tags.length >= MAX_TAGS
                  ? 'Maximum 20 keywords reached'
                  : `${tags.length} keyword${tags.length > 1 ? 's' : ''} added — ${MAX_TAGS - tags.length} more allowed`}
              </span>
              <span className="kcount">
                <span className="n">{tags.length}</span>&nbsp;/ {MAX_TAGS}
              </span>
            </div>

            <div className={`kwarn ${tags.length > 0 && tags.length < MIN_TAGS ? 'show' : ''}`}>
              ⚠ Minimum 5 keywords required
            </div>
          </div>

          <button
            className={`mic ${isKeywordListening ? 'on' : ''}`}
            style={{ marginTop: 4 }}
            onClick={startKeywordVoice}
            type="button"
          >
            <svg viewBox="0 0 24 24" fill={isKeywordListening ? 'white' : 'var(--muted)'}>
              <path d="M12 14c1.7 0 3-1.3 3-3V5c0-1.7-1.3-3-3-3S9 3.3 9 5v6c0 1.7 1.3 3 3 3zm5.3-3c0 3-2.5 5.1-5.3 5.1S6.7 14 6.7 11H5c0 3.4 2.7 6.2 6 6.7V21h2v-3.3c3.3-.5 6-3.3 6-6.7h-1.7z"/>
            </svg>
          </button>
        </div>

        <div className={`vs ${isKeywordListening ? 'show' : ''}`}>
          <div className="vwave">
            <span/><span/><span/><span/><span/>
          </div>
          Listening — speak your keywords…
        </div>
      </div>

      <button className="btn" onClick={handleNext} disabled={!isStepValid}>
        Continue to GMB Profile
        <svg viewBox="0 0 24 24">
          <path d="M12 4l-1.4 1.4L16.2 11H4v2h12.2l-5.6 5.6L12 20l8-8z"/>
        </svg>
      </button>
    </>
  );
};

// ─── SMALL INLINE ICONS ───────────────────────────────────────────────────────

const SparkleIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none"
    stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M12 2l2.4 7.4H22l-6.2 4.5 2.4 7.4L12 17l-6.2 4.3 2.4-7.4L2 9.4h7.6z"/>
  </svg>
);

const SpinnerIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none"
    stroke="currentColor" strokeWidth="2.5" strokeLinecap="round"
    style={{ animation: 'brandInfoSpin 0.8s linear infinite' }}>
    <style>{`@keyframes brandInfoSpin { to { transform: rotate(360deg); } }`}</style>
    <path d="M12 2a10 10 0 0 1 10 10" opacity="1"/>
    <path d="M22 12a10 10 0 0 1-10 10" opacity="0.4"/>
    <path d="M12 22a10 10 0 0 1-10-10" opacity="0.2"/>
    <path d="M2 12a10 10 0 0 1 10-10" opacity="0.6"/>
  </svg>
);

export default BrandInfo;